import { forwardRef } from "react";

const CustomInput = ({ value, onClick }) => {
    return (
        <div className="custom-input" onClick={onClick}>
            <input type="text" value={value} />
            <img src="/icons/calendar.png" className="ic x2" />
        </div>
    )
};
  

export default CustomInput;